// L'interruttore dell'animazione della città (artboard 56): una scelta di chi guarda, ricordata
// dal browser. Di partenza la città si muove, salvo «riduci movimento» del sistema.
import { useState } from 'react';
import { Icon } from '../../components/Icon';

const KEY = 'poptown.login.motion';

function initial(): boolean {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved !== null) return saved === '1';
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return true;
  }
}

export function useTownMotion(): [boolean, (on: boolean) => void] {
  const [motion, setMotion] = useState(initial);
  const set = (on: boolean) => {
    setMotion(on);
    try {
      localStorage.setItem(KEY, on ? '1' : '0');
    } catch {
      /* senza storage la scelta vale finché la pagina è aperta */
    }
  };
  return [motion, set];
}

export function MotionToggle({
  motion,
  onChange,
}: {
  motion: boolean;
  onChange: (on: boolean) => void;
}) {
  return (
    <button
      type="button"
      className="town-toggle"
      aria-pressed={motion}
      onClick={() => onChange(!motion)}
      title={motion ? 'Ferma la città' : 'Anima la città'}
    >
      <Icon name={motion ? 'pause' : 'play'} size={16} />
      {motion ? 'Ferma la città' : 'Anima la città'}
    </button>
  );
}
